import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Markdown from "@/components/Markdown";

function LegalShell({ title, field, fallback }) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/settings")
      .then(({ data }) => setText(data?.[field] || ""))
      .finally(() => setLoading(false));
  }, [field]);

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16" data-testid={`legal-${field}`}>
      <div className="h-1 w-12 bg-[#00E5FF] mb-3" />
      <div className="eyebrow text-[#00E5FF]">Rechtliches</div>
      <h1 className="font-display font-black italic uppercase tracking-normal text-5xl sm:text-6xl leading-none mt-2">
        {title}
      </h1>
      <div className="mt-8">
        {loading
          ? <div className="text-sm text-neutral-400">Lädt…</div>
          : (text
              ? <Markdown>{text}</Markdown>
              : <div className="text-sm text-neutral-500 italic">{fallback}</div>
            )
        }
      </div>
    </div>
  );
}

export function ImpressumPage() {
  return (
    <LegalShell
      title="Impressum"
      field="impressum"
      fallback="Noch kein Impressum hinterlegt. Der Admin kann den Text im Admin → Konfiguration → Footer eintragen."
    />
  );
}

export function DatenschutzPage() {
  return (
    <LegalShell
      title="Datenschutz"
      field="datenschutz"
      fallback="Noch keine Datenschutzerklärung hinterlegt. Der Admin kann den Text im Admin → Konfiguration → Footer eintragen."
    />
  );
}
